export default [{
  id: 1001,
  key: 1001,
  value: '娱乐'
}, {
  id: 1002,
  key: 1002,
  value: '游戏'
}, {
  id: 1003,
  key: 1003,
  value: '体育'
}, {
  id: 1004,
  key: 1004,
  value: '时尚'
}, {
  id: 1005,
  key: 1005,
  value: '生活'
}, {
  id: 1006,
  key: 1006,
  value: '社会'
}, {
  id: 1007,
  key: 1007,
  value: '人文'
}, {
  id: 1008,
  key: 1008,
  value: '汽车'
}, {
  id: 1009,
  key: 1009,
  value: '女人'
}, {
  id: 1010,
  key: 1010,
  value: '旅游'
}, {
  id: 1011,
  key: 1011,
  value: '科技'
}, {
  id: 1012,
  key: 1012,
  value: '军事'
}, {
  id: 1013,
  key: 1013,
  value: '教育'
}, {
  id: 1014,
  key: 1014,
  value: '互联网'
}, {
  id: 1015,
  key: 1015,
  value: '国内'
}, {
  id: 1016,
  key: 1016,
  value: '国际'
}, {
  id: 1017,
  key: 1017,
  value: '搞笑'
}, {
  id: 1018,
  key: 1018,
  value: '房产'
}, {
  id: 1019,
  key: 1019,
  value: '财经'
}, {
  id: 1020,
  key: 1020,
  value: '图片'
}, {
  id: 1021,
  key: 1021,
  value: '综合'
}]
